import React from "react";
//import PropTypes from "prop-types";
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";

import NumberFormat from 'react-number-format';
import moment from 'moment';

// core components
import RequirementsCard from "components/Cards/RequirementsCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import RegularCard from "components/Cards/RegularCard.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Table from "components/Table/Table.jsx";

import {stripe} from "variables/variables.jsx";

import { getStripeConnectLink, getStripeLoginLink, getTransfers } from '../../actions/payment'


class Account extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {

    this.props.dispatchGetStripeConnectLink(this.props.auth.user);
    this.props.dispatchGetStripeLoginLink(this.props.auth.user);
    this.props.dispatchGetTransfers(this.props.auth.user);

  }

  render() {
    const {  translate, classes, stripeConnectLink, stripeLoginLink, userDetails, transfers } = this.props;

    var payoutsTableData = [];
    if(transfers.length>0){
      transfers.map((prop,key)=>{
        let amount = (<NumberFormat value={prop.amount/100} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />);
        payoutsTableData.push([ moment(prop.created*1000).format('MMM Do YYYY, h:mm a'), amount, prop.description, "**** "+prop.source.last4]);
        return false;
      });
    }        

    return (
      <div>
        <GridContainer>
          {this.state.alert}        
          <ItemGrid xs={12} sm={12} md={6}>
            <RequirementsCard content={translate("requirements.receiver_account.content")} />
          </ItemGrid>    

          <ItemGrid xs={12} sm={12} md={6}>
            <RegularCard
              iconColor="rose"
              title="Edit"
              content={
                <div>
                  <div dangerouslySetInnerHTML={{ __html: translate("layout.content.receiver_stripe_intro") }} />
                  {(stripeConnectLink&&userDetails.stripeAccountId==="")?(
                    <div>
                      <Button 
                        color="primary"
                        href={stripeConnectLink}
                        >
                        {translate("layout.content.receiver_connect_stripe")}
                      </Button>
                    </div>
                    ):""}
                  {stripeLoginLink&&userDetails.stripeAccountId?(
                    <div>
                      <h3>Your account is connected.</h3>
                      <Button 
                        color="primary"
                        href={stripeLoginLink}
                        target="_blank"
                        >
                        {translate("layout.content.receiver_login_stripe")}
                      </Button>
                    </div>
                    ):""}
                </div>
              }
            />
          </ItemGrid>  
          <ItemGrid xs={12} sm={12} md={6}>
            <RegularCard
              iconColor="rose"
              title="My Payouts"
              content={
                <Table
                  tableHead={[
                    "Date",
                    "Amount",
                    "Description",
                  ]}
                  tableData={payoutsTableData}
                />
              }
            />
          </ItemGrid>                                
        </GridContainer>
      </div>
    );
  }
}


const mapDispatchToProps = {
  dispatchGetStripeConnectLink: (user ) => getStripeConnectLink(user),
  dispatchGetStripeLoginLink: (user ) => getStripeLoginLink(user),
  dispatchGetTransfers: (user ) => getTransfers(user),
}

const mapStateToProps = (state, props) => {
  return {
    translate: getTranslate(state.localize),
    auth: state.auth,
    stripeConnectLink: state.user.stripeConnectLink,
    stripeLoginLink: state.user.stripeLoginLink,
    userDetails: state.user.userDetails,
    transfers: state.user.transfers,
  }
}


export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(Account);




// WEBPACK FOOTER //
// ./src/views/Receiver/Account.jsx